<!-- Navigation-->
<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
  <div class="container">
    <a class="navbar-brand" [routerLink]="['/']">Editor de Conteúdos</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">

      <ul class="navbar-nav ml-auto">
        <li class="nav-item" *ngFor="let item of itensMenu">
          <a *ngIf='exibirItem(item.admin)' class="nav-link" [routerLink]="item.link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:item.exact}">{{item.name}}</a>
        </li>
        <!-- <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/inicio']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" >Inicio</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/sobre']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" >Sobre</a>
                </li> -->
      </ul>
      <app-menu-login></app-menu-login>
    </div>
  </div>
</nav>
<!--Fim Navigation-->